import React from 'react';
import { Toast as AntdToast } from 'antd-mobile';
import s from './index.less';

function getDuration(duration?: number) {
  if (duration === undefined) {
    return 2000;
  }

  if (duration === 0 || duration > 1000) {
    return 0;
  }

  return duration * 1000;
}

export default {
  info: (content: React.ReactNode, duration?: number) => {
    AntdToast.show({
      content,
      duration: getDuration(duration),
    });
  },
  hide: () => {
    AntdToast.clear();
  },
  loading: (content: React.ReactNode, duration?: number) => {
    AntdToast.show({
      icon: 'loading',
      content,
      duration: getDuration(duration),
    });
  },
  success: (content: React.ReactNode, duration?: number) => {
    AntdToast.show({
      icon: (
        <img
          className={s.icon_success}
          src={require('@/assets/images/3.9/toastsuccess.png')}
          alt=""
        />
      ),
      content,
      duration: getDuration(duration),
    });
  },
  fail: (content: React.ReactNode, duration?: number) => {
    AntdToast.show({
      icon: 'fail',
      content,
      duration: getDuration(duration),
    });
  },
};
